import React from 'react';
import styled from 'styled-components';

import CopyToClipboard from '#/components/basic/icons/CopyToClipboard';
import Callout from '#/components/s2/Callout';
import Spacer from '#/components/s2/Spacer';

const Wrapper = styled.div`
  font-size: var(--medium2);
  line-height: 1.5;

  label {
    display: block;
    font-size: var(--medium);
    padding: 14px 0 8px;
  }
`;

function CopyValuesContainer({
  delegatedPrivateKey,
  delegatedNonce,
}: {
  delegatedPrivateKey: string;
  delegatedNonce: string;
}) {
  return (
    <div>
      <label>Copy Session Key</label>
      <CopyToClipboard copyText={delegatedPrivateKey} taller />
      <label>Copy Nonce</label>
      <CopyToClipboard copyText={delegatedNonce} />
    </div>
  );
}

type Props = {
  delegatedPrivateKey: string;
  delegatedNonce: string;
};

export default function WalletAuthDetails({
  delegatedPrivateKey,
  delegatedNonce,
}: Props) {
  return (
    <>
      <Wrapper>
        <span>
          You have created a session keypair that can be exported to third party
          terminals.
        </span>
        <Spacer height={12} />
        <Callout type="warn">
          Once you have closed out of this modal you will no longer be able to
          retrieve this information.
        </Callout>
        <CopyValuesContainer
          delegatedPrivateKey={delegatedPrivateKey}
          delegatedNonce={delegatedNonce}
        />
      </Wrapper>
    </>
  );
}
